module.exports = __webpack_public_path__ + "img/risk-icon.4bc0d3c0.png";